/* Cross-cluster upsell injected into the cart drawer.
 *
 * The drawer is a compiled Svelte app mounted on #cart-drawer, so there is no
 * Liquid hook inside it. A MutationObserver re-injects the block whenever the
 * drawer re-renders. Cluster data comes from the JSON emitted by
 * snippets/cart-cluster-upsell.liquid.
 */
(function () {
  var dataEl = document.querySelector('[data-cluster-upsell-data]');
  var mount = document.getElementById('cart-drawer');
  if (!dataEl || !mount) return;

  var config = JSON.parse(dataEl.textContent);
  var cartState = null;
  var fetching = false;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function clusterOf(productId) {
    for (var i = 0; i < config.clusters.length; i++) {
      if (config.clusters[i].productIds.indexOf(productId) !== -1) return config.clusters[i].key;
    }
    for (var j = 0; j < config.onePacks.length; j++) {
      if (config.onePacks[j].id === productId) return config.onePacks[j].cluster;
    }
    return null;
  }

  function missingClusters(cart) {
    var present = {};
    cart.items.forEach(function (item) {
      var key = clusterOf(item.product_id);
      if (key) present[key] = true;
    });
    if (Object.keys(present).length === 0) return [];
    return config.clusters.filter(function (cluster) {
      return !present[cluster.key] && cluster.card.available && cluster.card.variantId;
    });
  }

  function buildBlock(clusters) {
    var block = document.createElement('div');
    block.className = 'cluster-upsell';
    block.setAttribute('data-cluster-upsell', 'true');

    var title = document.createElement('p');
    title.className = 'cluster-upsell__title';
    title.textContent = 'Goes great with your order';
    block.appendChild(title);

    var cards = document.createElement('div');
    cards.className = 'cluster-upsell__cards';
    clusters.forEach(function (cluster) {
      var card = document.createElement('div');
      card.className = 'cluster-upsell__card';

      var img = document.createElement('img');
      img.className = 'cluster-upsell__img';
      img.src = cluster.card.image;
      img.alt = cluster.card.title;
      img.loading = 'lazy';
      card.appendChild(img);

      var info = document.createElement('span');
      info.className = 'cluster-upsell__info';
      var name = document.createElement('span');
      name.className = 'cluster-upsell__name';
      name.textContent = cluster.title + ' · ' + cluster.card.variantTitle;
      var price = document.createElement('span');
      price.className = 'cluster-upsell__price';
      price.textContent = money(cluster.card.price);
      info.appendChild(name);
      info.appendChild(price);
      card.appendChild(info);

      var button = document.createElement('button');
      button.className = 'cluster-upsell__add';
      button.type = 'button';
      button.textContent = 'Add';
      button.addEventListener('click', function () {
        button.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: cluster.card.variantId, quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            cartState = null;
            if (typeof window.updateCart === 'function') {
              window.updateCart();
            } else {
              document.dispatchEvent(new CustomEvent('update-cart'));
            }
          })
          .catch(function () {
            button.disabled = false;
          });
      });
      card.appendChild(button);
      cards.appendChild(card);
    });
    block.appendChild(cards);
    return block;
  }

  function inject() {
    var anchor = mount.querySelector('.flow-root');
    if (!anchor) return; // drawer closed or empty
    if (mount.querySelector('[data-cluster-upsell]')) return;

    if (!cartState) {
      if (fetching) return;
      fetching = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          cartState = cart;
          fetching = false;
          inject();
        })
        .catch(function () {
          fetching = false;
        });
      return;
    }

    if (cartState.item_count === 0) return;
    var clusters = missingClusters(cartState);
    if (!clusters.length) return;
    anchor.insertAdjacentElement('afterend', buildBlock(clusters));
  }

  var observer = new MutationObserver(function (mutations) {
    var external = mutations.some(function (mutation) {
      var node = mutation.target;
      return !(node.closest && node.closest('[data-cluster-upsell]'));
    });
    if (!external) return;
    cartState = null; // drawer re-rendered: cart likely changed
    inject();
  });
  observer.observe(mount, { childList: true, subtree: true });

  document.addEventListener('update-cart', function () {
    cartState = null;
  });
})();
